define('app-AddressLookup/main',['./settings', './viewModel', 'text!./view.html', '../app/ui/dialog', 'knockout'],
    function (settings, ViewModel, view, dialog, ko) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('ADDRESS PICKER container not found.  app-AddressLookup will not be available.');
                    return;
                }

                container.each(function () {
                    var $this = $(this);
                    var vm = new ViewModel();
                    var $d = $('#PostCode');
                    
                    if ($d.length != 0 && $d.data('postcodeval').length != 0) {
                        vm.populatePostCode($d.data('postcodeval'));
                    }

                    ko.applyBindings(vm, $this.first()[0]);

                    var manualAddress = null;

                    $this.find('.loadManualAddress').click(function (e) {
                        e.preventDefault();

                        if (manualAddress && manualAddress.isOpen()) {
                            return;
                        }

                        var v = $(view).clone();
                        manualAddress = dialog.show('Enter your address manually', $(v), { noClose: true });
                        vm.manualDialog = manualAddress;
                        ko.applyBindings(vm, manualAddress[0]);
                    });
                });

                window.loadedModules("app-AddressLookup");
            }
        }
    });
